import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React from "react"
import "./section-versus-v2.scss"

const SectionVersusV2 = ({
  callsToAction,
  versusColumnSections,
  vsHeading,
}) => {
  return (
    <section className="section-versus-v2">
      <div className="container-v2">
        {vsHeading?.heading && (
          <h2 className="section-versus-v2--heading">
            <TextLockupV2>{vsHeading.heading}</TextLockupV2>
          </h2>
        )}

        {versusColumnSections && versusColumnSections.length > 0 && (
          <div className="section-versus-v2--column-sections">
            {versusColumnSections.map(section => (
              <div
                className="section-versus-v2--column-section"
                key={section.id}
              >
                <h3 className="section-versus-v2--column-section-title">
                  {section.title}
                </h3>
                {section.versusSubSections &&
                  section.versusSubSections.length > 0 && (
                    <div className="section-versus-v2--column-section-sub-sections">
                      {section.versusSubSections.map(subSection => (
                        <div
                          className="section-versus-v2--column-section-sub-section"
                          key={subSection.id}
                        >
                          <h4 className="section-versus-v2--column-section-sub-section-title">
                            {subSection.title}
                          </h4>
                          {subSection.text?.childrenMarkdownRemark?.[0]
                            ?.html && (
                            <div
                              className="section-versus-v2--column-section-sub-section-text-content"
                              dangerouslySetInnerHTML={{
                                __html:
                                  subSection.text.childrenMarkdownRemark[0]
                                    .html,
                              }}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  )}
              </div>
            ))}
          </div>
        )}

        {callsToAction && callsToAction?.length > 0 && (
          <div className="page-hero-v2--content-buttons">
            {callsToAction.map(action => (
              <p className="page-hero-v2--content-button" key={action.id}>
                <ButtonV2
                  accessibilityLabel={action.accessibilityLabel}
                  className={getButtonClasses(
                    action.buttonStyle || "primary-green",
                    action.buttonSize || "large"
                  )}
                  href={action.path}
                  key={action.id}
                  showArrow={action.showArrow === "Yes" ? true : false}
                  text={action.text}
                />
              </p>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

SectionVersusV2.propTypes = {
  callsToAction: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  versusColumnSections: PropTypes.array.isRequired,
  vsHeading: PropTypes.string.isRequired,
}

export default SectionVersusV2
